import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { exportRequest } from './exportRequest';

export const inputActions = [exportRequest];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
